import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '@/components/infoPages/HomePage'
import { withPublicPageSeo } from '@/modules/seo'

const HomePageWithSeo = withPublicPageSeo('home', HomePage)

export const Route = createFileRoute('/$lang/')({
  component: HomePageWithSeo,
})
